import { DEVIS_COMMANDE_ETAT, SENS_ACHAT } from '@/configuration/devisConf';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import { get as getFacture } from '@/api/facture';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';
import { getAll as getAllSignatures } from '@/api/signatureElectronique';
import getInfosSignaturePourDevisCommande from '@/services/signatureElectronique/getInfosSignaturePourDevisCommande';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export function getLibelleEtatDevisCommandeFacture(etat, listeEtat) {
  const etatFind = listeEtat.find((etatDcf) => { return etatDcf.code === etat; });
  return etatFind ? etatFind.libelle : null;
}

export function createObjectArianeEmpty(libelle) {
  return {
    libelle: libelle,
    link: null,
    paramLink: null,
    isActive: false,
    customClassMarker: null,
    sousLibelle: null,
    icon: null,
    customClassSegment: null,
    iconSignatureColor: null,
    infoSurSiganture: null,
  };
}

export function updateObjectFilAriane(
  objectFilAriane, libelle, link, paramLink,
  isActive, customClassMarker, sousLibelle, icon, customClassSegment,
  paramsLibelle, signatureInfo,
) {
  objectFilAriane.libelle = libelle;
  objectFilAriane.link = link;
  objectFilAriane.paramLink = paramLink;
  objectFilAriane.isActive = isActive;
  objectFilAriane.customClassMarker = customClassMarker;
  objectFilAriane.sousLibelle = sousLibelle;
  objectFilAriane.icon = icon;
  objectFilAriane.customClassSegment = customClassSegment;
  objectFilAriane.paramsLibelle = paramsLibelle;
  objectFilAriane.iconSignatureColor = signatureInfo?.iconColor || null;
  objectFilAriane.infoSurSiganture = signatureInfo?.message || null;
}

export async function getToolTipSignatureInfo(id) {
  let toolTipSignatureInfo = {};
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.signatureElectronique.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];

  if (parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key)) {
    const signaturesHisto = (await getAllSignatures({
      query: {
        referenceId: id,
        societeId: store.getters['societe/societeActiveId'],
      },
      MaxResultCount: NO_PAGINATION,
      SkipCount: 0,
    })).data.result.items;
    toolTipSignatureInfo = getInfosSignaturePourDevisCommande(signaturesHisto);
  }
  return toolTipSignatureInfo;
}

export async function setInfoDevisWithCommandeOrAcompte(commandeOrAcompte, tabFilAriane) {
  if (commandeOrAcompte.referenceId) {
    const toolTipSignatureInfo = await getToolTipSignatureInfo(commandeOrAcompte.referenceId);
    const devis = commandeOrAcompte.reference;
    updateObjectFilAriane(tabFilAriane[0], tabFilAriane[0].libelle, 'c.bodac.devis', { id: devis.id }, true, null, getLibelleEtatDevisCommandeFacture(devis.etat, DEVIS_COMMANDE_ETAT), 'check-bold',
      null, null, toolTipSignatureInfo);
    return;
  }
  updateObjectFilAriane(tabFilAriane[0], tabFilAriane[0].libelle, null, null, false, 'steps-marker-notActive', null, null, 'notActive');
}

export async function setInfoFactureWithCommande(commande, tabFilAriane, isVenteInterne) {
  let listFactures = [];
  commande.echeanciers.forEach((echeancier) => {
    const ligneEcheancierFacture = echeancier.echeancierLignes.filter((ligne) => {
      return ligne.facturationFaite && ligne.factureId;
    });
    listFactures = listFactures.concat(ligneEcheancierFacture.map(ligne => ligne.factureId));
  });
  listFactures = [...new Set(listFactures)];
  if (listFactures.length === 0) return;
  if (listFactures.length > 1) {
    updateObjectFilAriane(tabFilAriane[2], 'detailFacture.multiTypeFacture', 'l.bodac.factures-referencesIds', { referenceIds: commande.id }, true, null, null, 'check-bold');
    return;
  }
  const facture = (await getFacture(listFactures[0])).data.result;
  let routeNameFacture = 'c.bodac.factures';
  if (isVenteInterne) {
    routeNameFacture = commande.sens === SENS_ACHAT ? 'c.bodac.factures-achatVenteInterne' : 'c.bodac.factures-venteInterne';
  }
  updateObjectFilAriane(tabFilAriane[2], tabFilAriane[2].libelle, routeNameFacture, { id: facture.id }, true, null, getLibelleEtatDevisCommandeFacture(facture.etat, FACTURE_ETAT), 'check-bold');
}

export function createTabFilAriane() {
  return [
    createObjectArianeEmpty('detailDevis.typeDevis'),
    createObjectArianeEmpty('detailCommande.typeCommande'),
    createObjectArianeEmpty('detailFacture.typeFacture'),
  ];
}
